import {Component, Input, OnInit} from '@angular/core';
import {
    Aangifte, AangifteBerekening,
    AangifteRapport, IncomeTaxEntity,
    OpbouwPVV,
    SpecificatiePVV
} from "@snelstart-ventures/fiscaal/domain-logic";
import {BokkzIbDataService} from "@snelstart-ventures/fiscaal/domain-logic";
import {AbstractControl, FormBuilder, FormControl, FormGroup} from "@angular/forms";
import {BehaviorSubject, combineLatest} from "rxjs";
import { SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-spec-premie-volksverzekeringen',
  templateUrl: './spec-premie-volksverzekeringen.component.html',
  styleUrls: ['./spec-premie-volksverzekeringen.component.scss'],
  imports: [
    SharedUiFormControlsModule,
    CommonModule
  ]
})
export class SpecPremieVolksverzekeringenComponent implements OnInit {

  @Input() public id!: string;
    public aangifte = {} as Aangifte;
    public incomeTaxEntity = {} as IncomeTaxEntity;

    @Input() partner = new BehaviorSubject<boolean>(false);
    public partnerBoolean = false;
    private partnerAangifte = {} as Aangifte;

    specPVVFormGroup = this.fb.group<AangifteRapport>({});
    specPVV = {} as AangifteRapport;
    aangeverRapport = {} as AangifteRapport;
    partnerRapport = {} as AangifteRapport;
    berekeningBox1 = {} as AangifteBerekening;
    aangeverBerekening = {} as AangifteBerekening;
    partnerBerekening = {} as AangifteBerekening;

    propertyNamesToCheck: string[] = [
        'premieInkomenAOWenANW',
        'premieInkomenWLZenAZVW',
        'aowPercentage',
        'gecombineerdHeffingspercentage',
        'premieAOW',
        'premieANW',
        'premieWLZ',
    ];

    propertyTextMap: Record<string, string> = {
        premieInkomenAOWenANW: 'Premie-inkomen AOW en ANW',
        premieInkomenWLZenAZVW: 'Premie-inkomen WLZ',
        aowPercentage: 'AOW-percentage',
        gecombineerdHeffingspercentage: 'Gecombineerd heffingspercentage',
        premieAOW: 'Premie AOW',
        premieANW: 'Premie ANW',
        premieWLZ: 'Premie WLZ',
    };

    getPropertyValueMultiplied(propertyName: string): number | null {
        const value = this.getPropertyValue(propertyName);
        if (propertyName === 'gecombineerdHeffingspercentage') {
            return value !== null ? value * 100 : null;
        }
        return value !== null ? value * 100 : null;
    }

    getPropertyValue(propertyName: string): number | null {
        const control = this.specPVVFormGroup.get(['specificatiePVV', 'opbouw', propertyName]);
        return control ? control.value : null;
    }

    constructor(public dataService: BokkzIbDataService, private fb: FormBuilder) {
        this.specPVVFormGroup = this.fb.group<AangifteRapport>(({
            specificatiePVV: this.fb.group<SpecificatiePVV>(({
                opbouw: this.fb.group<OpbouwPVV>(({
                    premieInkomenAOWenANW: null as unknown as number,
                    premieInkomenWLZenAZVW: null as unknown as number,
                    premieAOW: null as unknown as number,
                    premieANW: null as unknown as number,
                    premieWLZ: null as unknown as number,
                    aowPercentage: null as unknown as number,
                    gecombineerdHeffingspercentage: null as unknown as number,
                } as OpbouwPVV))
            } as SpecificatiePVV))
        } as AangifteRapport))
    }

    public ngOnInit(): void {
        combineLatest([this.dataService.incomeTaxEntity,
            this.dataService.aangifteBerekening,
            this.dataService.aangifteRapport,
            this.dataService.partnerAangifteRapport,
        ]).subscribe(
            ([incomeTaxEntity, berekening, aangeverRapport,partnerRapport]) => {
                this.specPVVFormGroup.reset()
                if (incomeTaxEntity) {
                    this.incomeTaxEntity=incomeTaxEntity;
                    if (berekening) {
                        this.aangeverBerekening=berekening;
                        if (berekening.partnerBerekening) {
                            this.partnerBerekening = berekening.partnerBerekening;
                        }
                    }
                    if (aangeverRapport) {
                        this.aangeverRapport=aangeverRapport
                    }
                    if (partnerRapport) {
                        this.partnerRapport=partnerRapport
                    }
                }
                if (incomeTaxEntity.aangifte) {
                    this.partner.subscribe((partner) => {
                        this.partnerBoolean = partner;
                        this.specPVVFormGroup.reset();
                        if (partner) {
                            this.specPVV = this.partnerRapport;
                            this.specPVVFormGroup.patchValue(this.specPVV)
                            this.loadMultipliedValues();
                        } else if (!partner) {
                            this.specPVV = this.aangeverRapport;
                            this.specPVVFormGroup.patchValue(this.specPVV)
                            this.loadMultipliedValues();
                        }
                    })
                }
            })
    }

    loadMultipliedValues(): void {
        this.propertyNamesToCheck.forEach((propertyName) => {
            if (propertyName === 'gecombineerdHeffingspercentage') {
                const multipliedValue = this.getPropertyValueMultiplied(propertyName);
                this.specPVVFormGroup.get(['specificatiePVV', 'opbouw', propertyName])?.setValue(multipliedValue);
            }
        });
    }

    disableFormGroup(formGroup: FormGroup | AbstractControl): void {
        if (formGroup instanceof FormGroup) {
            Object.keys(formGroup.controls).forEach((key) => {
                const control = formGroup.get(key);
                if (control instanceof FormControl) {
                    control.disable();
                } else if (control instanceof FormGroup) {
                    this.disableFormGroup(control);
                }
            });
        }
    }

}

